import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {getSellLimit, deleteSellLimit} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class DeleteSellLimitForm extends Component {
  componentDidMount() {
    const {sellLimitId} = decodeParams(this.props.match.params);
    this.props.getSellLimit({sellLimitId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const {sellLimitId} = decodeParams(this.props.match.params);
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.deleteSellLimit({...values, sellLimitId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, sellLimit, sellLimitLoading} = this.props;
    const {name} = sellLimit || {};
    return (
      <Card title="Delete Sell Limit" loading={sellLimitLoading}>
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {name}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Reason"
          >
            {getFieldDecorator('reason', {
              rules: [{
                required: true
              }]
            })(
              <Input autoFocus />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Delete Sell Limit
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

DeleteSellLimitForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string,
  sellLimit: PropTypes.object,
  sellLimitLoading: PropTypes.bool.isRequired,
  getSellLimit: PropTypes.func.isRequired,
  deleteSellLimit: PropTypes.func.isRequired,
};

const DeleteSellLimitPage = Form.create()(DeleteSellLimitForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  sellLimit: state.sellLimit.sellLimit,
  sellLimitLoading: state.sellLimit.sellLimitLoading,
});

const mapDispatchToProps = dispatch => ({
  getSellLimit: payload => (dispatch(getSellLimit(payload))),
  deleteSellLimit: payload => (dispatch(deleteSellLimit(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSellLimitPage);



// WEBPACK FOOTER //
// ./src/SellLimit/DeleteSellLimitPage.js